import { isArray } from "@thi.ng/checks";
import { comp } from "../func/comp";
import { renamer } from "../func/renamer";
import { $iter } from "../iterator";
import { transduce } from "../transduce";
import { filter } from "./filter";
import { map } from "./map";
export function rename(...args) {
    const iter = args.length > 2 && $iter(rename, args);
    if (iter) {
        return iter;
    }
    let kmap = args[0];
    if (isArray(kmap)) {
        kmap = kmap.reduce((acc, k, i) => ((acc[k] = i), acc), {});
    }
    if (args[1]) {
        const ks = Object.keys(kmap);
        return map((y) => transduce(comp(map((k) => [k, y[kmap[k]]]), filter((x) => x[1] !== undefined)), args[1], ks));
    }
    else {
        return map(renamer(kmap));
    }
}
